export default __webpack_public_path__ + "static/media/sale2.dfed9529.png";